/**
 * Builds MUI <Autocomplete /> `onInputChange` for server-side keyword search
 * (use with debounced state, e.g. `useDebouncedKeywordState` from `@unit/hooks`).
 */
export const createKeywordSearchInputHandler =
  (schedule: (raw: string) => void, resetKeyword: () => void) =>
  (_event: unknown, newInputValue: string, reason: string): void => {
    if (reason === "input") {
      schedule(newInputValue);
    } else if (reason === "clear" || reason === "reset") {
      resetKeyword();
    }
  };
